import axios from "../reducers/authinterceptor";
import AuthHeader from "./auth.header";

const loadInventory = async (styleId) => {
  	var response = await axios
    	.get(process.env.REACT_APP_API_URL + "/admin/sanmarLoadInventory/" + styleId,
    { headers: AuthHeader.authHeader()});
	return response.data;
};
const updatePrices = async (styleId) => {
    var response = await axios
      .get(process.env.REACT_APP_API_URL + "/admin/sanmarUpdatePricesStyle/" + styleId,
  { headers: AuthHeader.authHeader()});
  return response.data;
};

const downloadPO = async (poId) => {
    axios
      .get(process.env.REACT_APP_API_URL + "/admin/purchaseorder/report/" + poId,
  { headers: {
    ...AuthHeader.authHeader()
    },
    responseType: 'blob'
  }).then((response) => {
    console.log(response);
    // create file link in browser's memory
    const href = URL.createObjectURL(new Blob([response.data]));

    // create "a" HTML element with href to file & click
    const link = document.createElement('a');
    link.href = href;
    link.setAttribute('download', `po_${poId}.xlsx`); //or any other extension
    document.body.appendChild(link);
    link.click();

    // clean up "a" element & remove ObjectURL
    document.body.removeChild(link);
    URL.revokeObjectURL(href);
  });

};

const removeFeatured = async(productId) => {
    var response = await axios
      .get(process.env.REACT_APP_API_URL + "/admin/removefeatured/" + productId,
  { headers: AuthHeader.authHeader()});
  return response.data;
};

const addFeatured = async(productId) => {
    try {
        var response = await axios
      .get(process.env.REACT_APP_API_URL + "/admin/addfeatured/" + productId,
  { headers: AuthHeader.authHeader()});
  console.log(response);
  return response.data;
      } catch (error) {
        console.log(error);
        return error.response.data;
    }
};

const getMaintenance = async () => {
    var response = await axios
      .get(process.env.REACT_APP_API_URL + "/admin/maintenance",
  { headers: AuthHeader.authHeader()});
  return response.data;
};

const allStyleReport = async () => {
    var response = await axios
      .get(process.env.REACT_APP_API_URL + "/admin/report/allStyles",
  { headers: AuthHeader.authHeader()});
  return response.data;
};
const AdminService = {
    loadInventory,
    updatePrices,
    downloadPO,
    removeFeatured,
    addFeatured,
    getMaintenance,
    allStyleReport
    
};
export default AdminService;